<template>
  <div class="cross" @click="handleClick">
    <div class="cross__container">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L17 16.9997"
          :class="{
            'white-cross': color === 'white',
            'black-cross': color === 'black',
          }"
          stroke="#FFF"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M1 17L17 1.00025"
          :class="{
            'white-cross': color === 'white',
            'black-cross': color === 'black',
          }"
          stroke="#FFF"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  color: {
    type: String,
    default: 'white',
  },
})

const emit = defineEmits(['click'])

const handleClick = (data) => {
  emit('click', data)
}
</script>

<style scoped lang="scss">
.cross {
  height: 1.6rem;
  width: 1.6rem;
  :hover {
    cursor: pointer;
  }
}

.white-cross {
  stroke: $color-white;
}

.black-cross {
  stroke: $color-main-text;
}
</style>
